export const Bio = {
  name: "Ragul R",
  roles: [
    "Full Stack Developer",
    "Web Developer",
    "Programmer",
  ],
  description:
    "Electronics and Communication Engineering graduate and full-stack developer with hands-on experience building scalable REST APIs and React.js applications using the full stack. Skilled in secure authentication, database design, and Agile collaboration, with a track record of delivering measurable performance improvements across internship and personal projects.",
  github: "https://github.com/r4gu1",
  resume:
    "https://drive.google.com/file/d/1KNjrVdzWvlOiPk4k5jT10P85G6xX5VrE/view?usp=sharing",
  linkedin: "https://www.linkedin.com/feed/?trk=onboarding-landing",
  WhatsApp: "https://wa.me/+918015194157",
  //insta: "https://www.instagram.com/ox_ragul_xo/",
  
};

export const skills = [
  {
    title: "Languages",
    skills: [
      {
        name: "Java",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
      },
      {
        name: "JavaScript",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      },
      {
        name: "C#",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/csharp/csharp-original.svg",
      },
      {
        name: "HTML",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
      },
      {
        name: "CSS",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      },
      {
        name: "SQL",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
      },
    ],
  },
  {
    title: "Frameworks",
    skills: [
      {
        name: "ASP.NET Core (.NET 9)",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dot-net/dot-net-original.svg",
      },
      {
        name: "Entity Framework Core",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/csharp/csharp-original.svg",
      },
      {
        name: "React.js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "Node.js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
      },
      {
        name: "Express.js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
      },
      {
        name: "REST APIs",
        image: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iOCIgZmlsbD0iIzE2MjhGQSIvPgo8dGV4dCB4PSI4IiB5PSIyMSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEwIiBmaWxsPSJ3aGl0ZSI+QVBJPC90ZXh0Pgo8L3N2Zz4=",
      },
      {
        name: "JWT",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/json/json-original.svg",
      },
    ],
  },
  {
    title: "Database / Tools",
    skills: [
      {
        name: "MySQL",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
      },
      {
        name: "Git",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      },
      {
        name: "GitHub",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
      },
      {
        name: "Postman",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg",
      },
      {
        name: "VS Code",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
      },
      {
        name: "Swagger",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swagger/swagger-original.svg",
      },
    ],
  },
];

export const experiences = [

  {
    id: 5,
    img: "https://th.bing.com/th/id/OIP.Wli0eVUSPwK9ura64I6CXwAAAA?w=159&h=81&c=3&r=0&o=7&dpr=1.5&pid=1.7&rm=2",
    role: "Executive Member| IQAC Club",
    company: "Sri Venkateswara College of Engineering",
    date: "June 2024 – Present",
    desc: "IQAC (Internal Quality Assurance Cell) Club is dedicated to promoting quality education and continuous improvement within the institution. As an Executive Member, I actively contribute to organizing workshops, seminars, and awareness programs that enhance the academic and professional development of students and faculty alike.",
    skills: [
      
      "Adaptability",
      "Analytical Thinking",
      "Technical Documentation",
    ],
    doc:""
  },
 
  // {
  //   id: 4,
  //   img: "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/uno.png",
  //   role: "Industrial Internship",
  //   company: "",
  //   date: "",
  //   desc: "Completed a hands-on internship with Uno Minda Pvt Ltd, a leading automotive components manufacturer, where I gained valuable experience in an engineering environment. This role strengthened my analytical and technical skills.",
  //   skills: [
  //     "Foundational Industry Knowledge",
  //     "Adaptability",
  //     "Analytical Thinking",
  //     "Technical Documentation",
  //   ],
  //   doc:"https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/uno1.jpg"
  // },
  
  {
    id: 0,
    img: "data:image/png;base64,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",
    role: "Error Makes Clever Academy",
    company: "MERN Stack Course",
    date: "Jun - Sep 2024",
    desc: "Completed a comprehensive training program on building full-stack web applications using the MERN stack:",
    skills: [
      "HTML","CSS","Tailwind CSS","JavaScript","React","Node.js","Express","MongoDB","Firebase","GitHub",
    ],
    doc: "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/Ragul%20R.png",
  },
 
  {
    id: 1,
    img: "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/infosys.png",
    role: "Infosys Springboard ",
    company: "C Programming Course",
    date: "Mar 2023",
    desc: "Completed a comprehensive C programming course through Infosys Springboard, enhancing foundational skills in software development.",
    skills: [
      "Programming Fundamentals",
      "Structured Programming",
      "Code Efficiency",
      "Debugging",
    ],
    doc: "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/infosis1.jpg",
  },
  // {
  //   id: 2,
  //   img: "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/nptel.png",
  //   role: "NPTEL COURSE",
  //   company: "Introduction to Industry 4.0 and Industrial Internet of Things ",
  //   date: "Jan - Apr 2024",
  //   desc: "Acquired in-depth knowledge in IIoT through a structured NPTEL course, focusing on integration and digital transformation in industrial applications.",
  //   doc: "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/nptel1.jpg",
  // },
  {
    id: 3,
    img: "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/ncc.jpeg",
    role: "NCC C CERTIFICATE",
    company: "National Cadet Corps",
    date: "sep 2022 - Present",
    desc: "Building a foundation of key skills: time management, leadership, and teamwork—through practical experiences and dedicated learning.",
    skills: [
      "Discipline",
      "Leadership",
      "Time management",
      "Teamwork",
    ],
    doc: "",
  },
  
 
];

export const education = [
  {
    id: 0,
    img:"https://images.shiksha.com/mediadata/images/1592381154phpAQiATq.jpeg",
    school: "Sri Venkateshwara College of Engineering",
    date: "Oct 2022 - Sep 2026",
    grade: "8.00 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Electronics and communication Engineering at Sri Venkateswara College of Engineering, Chennai. I have completed 6 semesters and have a CGPA of 8.00.",
    degree: "Bachelor of Engineering - BE, Electronics and Communication Engineering",
  },
  {
    id: 1,
    img:"https://yt3.ggpht.com/ytc/AKedOLTn3KKv7IasUW92UE3nZnslzgurYSxa0e3Gy6_o=s900-c-k-c0x00ffffff-no-rj",
    school: "Agasthiya group of School, Vandavasi",
    date: "Apr 2020 - Apr 2022",
    grade: "83.2%",
    desc: "I completed my class 12 high school education at Agasthiya Group of School, Vandavasi.",
    degree: "HSC (XII)",
  },
  {
    id: 2,
    img:"https://yt3.ggpht.com/ytc/AKedOLTn3KKv7IasUW92UE3nZnslzgurYSxa0e3Gy6_o=s900-c-k-c0x00ffffff-no-rj",
    school: "Agasthiya group of School, Vandavasi",
    date: "Apr 2019 - Apr 2020",
    grade: "93.3%",
    desc: "I completed my class 10 education at Agasthiya Group of school,Vandavasi.",
    degree: "SSLC (X)",
  },
];

export const internships = [
  {
    id: 0,
    img: "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/casa-logo.png", // replace with actual logo if available
    role: "Full Stack Developer Intern",
    company: "Casagrand Premier Builder Limited",
    date: "Chennai | Jan 2026 - May 2026",
    desc: [
      "Back end API implementation with Node.js and JWT authentication.",
      "Developed responsive React.js ticket management components and dashboard interfaces.",
      "Integrated MySQL database storage and SMTP email notifications for ticket lifecycle events.",
      "Collaborated in Agile cycles with code reviews and sprint-based feature delivery."
    ],
    skills: [
      "Full Stack Development",
      "Role-Based Access Control (RBAC)",
      "SMTP Integration",
      "Backend Development",
      "Frontend Development",
      "Database Management",
      "Problem Solving"
    ],
    doc: "", // add project demo or document link if available
  },
];

export const projects = [
 
  {
    id: 1,
    title: "Hand Gesture based Home Automation",
    date: "Jan 2024",
    description:
      "Developed a smart home system using CNN-based hand gesture recognition with OpenCV and Arduino, paired with a React Native app for customizable control, enhancing efficiency and reducing setup complexity across iOS and Android platforms.",
    image:
      "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/HandGesture.png",
    tags: [ "Python", "Arduino", "ReactJs" ],
    category: "Model Website",
    github: "https://github.com/r4gu1/HandGesture",
    webapp: "https://drive.google.com/file/d/1CRWzEstGa_oJKoxroHNoXwXez1C5UJtN/view?usp=sharing",
  },
  {
    id: 5,
    title: "Weather App",
    date: "OCT 2024",
    description:
      "My weather application is a responsive, user-friendly tool that adapts seamlessly to all devices. It features dynamic weather animations and a clean, clutter-free design for optimal usability. Built with precision, it showcases my expertise in frontend and backend development. This project blends functionality with visual appeal to deliver an engaging experience. ",
    image:
      "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/weather.png", 
    tags: ["HTML","CSS","JavaScript","React Js", "API Key"],
    category: "web app",
    github: "https://github.com/r4gu1/weather-app",
    webapp: "https://weather-app-one-lovat-48.vercel.app/",
  },
  {
    id: 6,
    title: "BulkMail App",
    date: "Sep 2024",
    description:
      "Developed a bulk email application capable of sending large volumes of emails efficiently and reliably. Enhanced application security with validation and error handling to manage large-scale data entries accurately.",
    image:
      "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/bulkmail.png",
    tags: ["HTML","Tailwind CSS","React","Express","Node.js","Mongodb"],
    category: "web app",
    github: "https://github.com/r4gu1/Mail-Sender",
    
  }, 
  {
    id: 2,
    title: "Udemy Clone",
    date: "Jun 2024",
    description:
      "I developed a responsive, user-friendly platform that mimics the structure of Udemy. This project features a clean layout, intuitive navigation, and a modern design, offering an immersive learning experience. It includes courses listing, search filters, and an interactive UI for easy course browsing.",
    image:
      "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/udemy.png",
    tags: ["HTML","CSS","media query","JavaScript"],
    category: "Model Website",
    github: "https://github.com/r4gu1/Udemy-react",
    webapp: "https://udemy-react-nu.vercel.app/",
  },
  {
    id: 4,
    title: "Todo Web App",
    date: "AUG 2024",
    description:
      " A Todo Web App made with React JS, JavaScript, HTML. It has a login page where users can log using Sign Up. It has a sidebar where users can see all the tasks and can create a new task.  It has a search bar where users can search for a particular task.",
    image:
      "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/todo1.png", 
      tags: ["HTML","CSS","JavaScript","React Js", "Local Storage","Node JS"],
    category: "web app",
    github: "https://github.com/r4gu1/Todo-App",
    webapp: "https://todo-app-pi-drab-85.vercel.app//",
  },


   {
    id: 3,
    title: "CRB Infestation Detection Website",
    date: "SEP 2025",
    description:
      " A web-based interface developed for the project 'Few-Shot Classification of Coconut Rhinoceros Beetle Infestation in Drone Images Using Prototypical Networks'. The website presents the research workflow, dataset details, model architecture (NotchNet with CBAM attention), experimental results, and performance analysis. It provides a structured and user-friendly platform to showcase the meta-learning approach used for CRB detection in coconut plantations.",
    image:
      "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/crbfsl.png", 
      tags: ["HTML","CSS","JavaScript","React Js", "Local Storage"],
    category: "web app",
    github: "https://github.com/r4gu1/CRBFSL",
    webapp: "https://crbfsl.vercel.app/",
  },

  {
  id: 7,
  title: "Requirement Buddy",
  date: "JAN 2026",
  description:
    "Requirement Buddy is an AI-powered automation tool designed to reduce the workload of Business Development teams in software companies. It processes client phone calls or text-based requirements, converts audio into text using AssemblyAI API, and extracts only the technical requirements using OpenRouter API. The system delivers structured technical summaries to BD teams, saving time and improving efficiency.",
  image: "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/Requirement-Buddy.png",
  tags: [
    "React JS",
    "Node JS",
    "OpenRouter API",
    "AssemblyAI API",
    "AI Automation",
  ],
  category: "Model Website",
  github: "https://github.com/r4gu1/Requirement-Buddy",
  webapp: "https://requirement-buddy.vercel.app/",
},
{
  id: 8,
  title: "Billing System",
  date: "2026",
  description:
    "Architected a billing system for a mobile accessories and repair shop with role-based access, 20+ RESTful CRUD endpoints, and automated invoice generation on Azure App Service.",
  image: "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/Billing_system.png",
  tags: ["ASP.NET Core", "C#", "Entity Framework Core", "SQL", "Azure"],
  category: "web app",
  github: "https://github.com/r4gu1/Billing-System",
  webapp: "",
},
{
  id: 9,
  title: "GreenCart",
  date: "2025",
  description:
    "Developed a responsive e-commerce app with React.js, Node.js, and Express.js, integrated Stripe payment processing and a secure admin panel for product management.",
  image: "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/greencart.png",
  tags: ["React.js", "Node.js", "Express.js", "SQL", "Stripe"],
  category: "web app",
  github: "https://github.com/r4gu1/GreenCart",
  webapp: "",
},
{
  id: 10,
  title: "CRUD Application",
  date: "2026",
  description:
    "Built a simple CRUD ASP.NET MVC application using Entity Framework and SQL Server LocalDB to manage student and employee records with create, read, update, and delete flows.",
  image: "https://raw.githubusercontent.com/r4gu1/portfolio-img/master/img/CRUD.png.png",
  tags: ["ASP.NET MVC", "C#", "Entity Framework 6", "SQL Server LocalDB"],
  category: "web app",
  github: "https://github.com/r4gu1/CRUD-using-entity",
  webapp: "",
}
];


